<template>
    <base-dblclick-textarea
        model-type="contactClientRelationship"
        :model-id="clientContact.id"
        field-name="contact_notes"
        :field-value="clientContact.contact_notes"
        @refetch="fetchNewClients"
    >
        <slot name="icon"></slot>
    </base-dblclick-textarea>
</template>

<script>
  export default {
      name: "company-contact-business-notes-cell"
  }

</script>

<script setup>
import {defineProps, defineEmits } from "vue";

  const props = defineProps(['clientContact'])

  const emit = defineEmits(['refetch-clients'])

  function fetchNewClients () {
      emit('refetch-clients')
  }


</script>